export const PREFERRED_LANGUAGE_GATE =
  'PortalsPlatform::SupportPreferredLanguage';
